import React from "react";

import {NavLink, Link } from "react-router-dom";
import { HashLink } from 'react-router-hash-link';

function Header() {
  const navRef = React.useRef(null);
  const navRef2 = React.useRef(null);
  
  const onAddClick = (e) => {
    navRef.current.classList.add("active");
    navRef2.current.classList.add("active");
  };
  const onRemoveClick = (e) => {
    navRef.current.classList.remove("active");
    navRef2.current.classList.remove("active");
  };
  return (<>

<div className="off_canvars_overlay" ref={navRef2} onClick={onRemoveClick}></div>
  <div className="offcanvas_menu">
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="offcanvas_menu_wrapper" ref={navRef}>
            <div className="canvas_close">
            <img src="assets/images/icons/close.png" alt="close" className="h19" onClick={onRemoveClick}  />
             
            </div>
         
            <div id="menu" className="text-left ">
              <ul className="offcanvas_main_menu">
                <li className="nav-item">
                  <Link to="/" className="nav-link active">
                    Home
                 
                  </Link>
          
                </li>
                <li className="nav-item">
                  <Link to="/about" className="nav-link">
                  About Us
                   
                  </Link>
           
                </li>
                <li className="nav-item">
                      <Link to="/banking-services" className="nav-link">
                        Banking Services
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/insurance-services" className="nav-link">
                       Insurance Services
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/wallet-services" className="nav-link">
                       Wallet Services
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/g2c-services" className="nav-link">
                       G2C Services
                      </Link>
                    </li>
                {/* <li className="nav-item">
                  <Link to="/news-blogs" className="nav-link">
                    News & Blog
                  </Link>
                 
                </li> */}
                <li className="nav-item">
                  <Link to="/contact" className="nav-link">
                    Contact Us
                  </Link>
                </li>
              </ul>
            </div>
           
          </div>
        </div>
      </div>
    </div>
  </div>



      {/* Start sub main Area */}
      <div className="header-area">
      <div className="container-fluid">
        <div className="row align-items-center">
     
          <div className="col-lg-6 col-sm-9 col-md-9">
            <div className="header-right-content text-start">
              <ul className="list-inline">
                <li className="d-inline">
                  <img src="assets/images/phone.svg" alt="Phone" />
                  <a href="tel:+91-9355200600">+91-9355200600</a>
                </li>
                <li className="d-inline">
                  <img src="assets/images/email.svg" alt="Email" />
                  <a href="#">
                    <span
                      className="__cf_email__"
                      >
                     info@smartuworld.com
                    </span>
                  </a>
                </li>
              </ul>
            </div>
          </div>

          {/* <div className="col-lg-6 col-sm-9 col-md-9">
            <div className="header-right-content text-end">
              <ul className="list-inline">
                <li className="d-inline">
                  <img src="assets/images/phone.svg" alt="Phone" />
                  <a href="tel:+91-9717111000">Support</a>
                </li>
                <li className="d-inline">
                  <img src="assets/images/email.svg" alt="Email" />
                  <a href="#">
                    <span
                      className="__cf_email__"
                      >
                    Help
                    </span>
                  </a>
                </li>
                <li className="d-inline">
                  <img src="assets/images/email.svg" alt="Email" />
                  <a href="#">
                    <span className="__cf_email__">
                        Business
                    </span>
                  </a>
                </li>
              </ul>
            </div>
          </div> */}
        </div>
      </div>
    </div>
    {/* End sub main Area */}
    {/* Start Navbar Area */}
    <div className="navbar-area">
      <div className="main-responsive-nav">
        <div className="container-fluid">
          <div className="main-responsive-menu">
            <div className="row">
              <div className="col-md-10">
              <div className="logo">
              <Link to="/">
                <img
                    src="assets/images/SSC.svg"
                  className="black-logo"
                  alt="image"
                />
                <img
                     src="assets/images/logo.png"
                  className="white-logo"
                  alt="image"
                />
              </Link>
            </div>
              </div>
              <div className="col-md-2">
              <div class="appie-btn-box text-right">
              <img src="assets/images/icons/menu.png" alt="close" onClick={onAddClick} className="h19" />
                      
                      </div>

              </div>
            </div>
        
          
          </div>
        </div>
      </div>
      <div className="main-navbar">
        <div className="container-fluid">
          <nav className="navbar navbar-expand-md navbar-light">
            <Link className="navbar-brand" to="/">
              <img
               src="assets/images/SSC.svg"
                className="black-logo"
                alt="image"
              />
              <img
                 src="assets/images/SSC.svg"
                className="white-logo"
                alt="image"
              />
            </Link>
            <div
              className="collapse navbar-collapse mean-menu"
              id="navbarSupportedContent"
            >
              <ul className="navbar-nav ms-auto">
                <li className="nav-item">
                  <NavLink to="/" className="nav-link" activeClassName="active">
                    Home
                 
                  </NavLink>
          
                </li>
                <li className="nav-item">
                  <NavLink to="/about" className="nav-link" activeClassName="active">
                  About Us
                   
                  </NavLink>
           
                </li>
                <li className="nav-item">
                  <Link to="#" className="nav-link">
                    Service we offer
                    <i className="bx bx-down-arrow-alt" />
                  </Link>
                  <ul className="dropdown-menu">
                  <div className="container">
                    <div className="row">
                      <div className="col-md-2">
                        <strong className="megaheading">Banking Service</strong>
                        <ul className="navbar-nav ms-auto megamenu">                         

                            <li className="nav-item">
                            <HashLink smooth to="/services#ser1" className="nav-link">
                                  Credit Card
                                </HashLink>
                            </li>
                            <li className="nav-item">
                            <HashLink smooth to="/services#ser2" className="nav-link">
                                 Bank Account
                                </HashLink>
                            </li>
                        </ul>
                      </div>

                      <div className="col-md-2">
                        <strong className="megaheading">Unsecured Loan</strong>
                        <ul className="navbar-nav ms-auto megamenu">                         

                            <li className="nav-item">
                            <HashLink smooth to="/services#ser3" className="nav-link">
                                 Personal Loan
                                </HashLink>
                            </li>
                            <li className="nav-item">
                            <HashLink smooth to="/services#ser4" className="nav-link">
                                Business Loan
                                </HashLink>
                            </li>
                            <li className="nav-item">
                            <HashLink smooth to="/services#ser9" className="nav-link">
                                Micro Loan under 50K
                                </HashLink>
                            </li>
                            <li className="nav-item">
                            <HashLink smooth to="/services" className="nav-link">
                                Education Loan
                                </HashLink>
                            </li>
                            <li className="nav-item">
                            <HashLink smooth to="/services" className="nav-link">
                                OD Limit
                                </HashLink>
                            </li>
                        </ul>
                      </div>

                      <div className="col-md-2">
                        <strong className="megaheading">Secured Loan</strong>
                        <ul className="navbar-nav ms-auto megamenu">                         

                            <li className="nav-item">
                            <HashLink smooth to="/services#ser4" className="nav-link">
                                 Housing Loan
                                </HashLink>
                            </li>
                            <li className="nav-item">
                            <HashLink smooth to="/services" className="nav-link">
                                OD Limit
                                </HashLink>
                            </li>
                            <li className="nav-item">
                            <HashLink smooth to="/services" className="nav-link">
                               Loan against Property
                                </HashLink>
                            </li>
                            <li className="nav-item">
                            <HashLink smooth to="/services#ser7" className="nav-link">
                                Gold Loan
                                </HashLink>
                            </li>
                            <li className="nav-item">
                            <HashLink smooth to="/services#ser8" className="nav-link">
                                Vehicle Loan
                                </HashLink>
                            </li>
                        </ul>
                      </div>

                      <div className="col-md-2">
                        <strong className="megaheading">Insurance Services</strong>
                        <ul className="navbar-nav ms-auto megamenu">                         

                            <li className="nav-item">
                            <HashLink smooth to="/services#ser10" className="nav-link">
                                 Motor Insurance
                                </HashLink>
                            </li>
                            <li className="nav-item">
                            <HashLink smooth to="/services#ser11" className="nav-link">
                                Life Insurance
                                </HashLink>
                            </li>
                            <li className="nav-item">
                            <HashLink smooth to="/services#ser12" className="nav-link">
                               Health Insurance
                                </HashLink>
                            </li>
                            <li className="nav-item">
                            <HashLink smooth to="/services#ser13" className="nav-link">
                               Group Insurance
                                </HashLink>
                            </li>
                        </ul>
                      </div>
                      
                      <div className="col-md-2">
                        <strong className="megaheading">Wallet Services</strong>
                        <ul className="navbar-nav ms-auto megamenu">                         

                            <li className="nav-item">
                            <HashLink smooth to="/services#ser14" className="nav-link">
                                AEPS
                                </HashLink>
                            </li>
                            <li className="nav-item">
                            <HashLink smooth to="/services#ser15" className="nav-link">
                                BBPS
                                </HashLink>
                            </li>
                            <li className="nav-item">
                            <HashLink smooth to="/services#ser16" className="nav-link">
                               Recharges
                                </HashLink>
                            </li>
                            <li className="nav-item">
                            <HashLink smooth to="/services#ser17" className="nav-link">
                              DMT
                                </HashLink>
                            </li>
                        </ul>
                      </div>

                      <div className="col-md-2">
                        <strong className="megaheading">G2C Services</strong>
                        <ul className="navbar-nav ms-auto megamenu">                         

                            <li className="nav-item">
                            <HashLink smooth to="/services#ser18" className="nav-link">
                                Passport
                                </HashLink>
                            </li>
                            <li className="nav-item">
                            <HashLink smooth to="/services#ser19" className="nav-link">
                                Marriage Certificate
                                </HashLink>
                            </li>
                            <li className="nav-item">
                            <HashLink smooth to="/services#ser20" className="nav-link">
                               Driving License
                                </HashLink>
                            </li>
                            <li className="nav-item">
                            <HashLink smooth to="/services#ser21" className="nav-link">
                              Caste Certificate
                                </HashLink>
                            </li>
                            
                            <li className="nav-item">
                            <HashLink smooth to="/services#ser22" className="nav-link">
                              Income Certificate
                                </HashLink>
                            </li>

                            
                            <li className="nav-item">
                            <HashLink smooth to="/services#ser23" className="nav-link">
                              Domicile Certificate
                                </HashLink>
                            </li>
                            
                            <li className="nav-item">
                            <HashLink smooth to="/services#ser24" className="nav-link">
                              Birth Certificate
                                </HashLink>
                            </li>


                        </ul>
                      </div>

                    </div>
                  </div>
                  </ul>
                </li>
                {/* <li className="nav-item">
                  <Link to="/news-blogs" className="nav-link">
                    News & Blog
                  </Link>
                 
                </li> */}
                <li className="nav-item">
                  <NavLink to="/contact" className="nav-link" activeClassName="active">
                    Contact Us
                  </NavLink>
                </li>
              </ul>
              <div className="others-options d-flex align-items-center">
               
                <div className="option-item">
                  <Link onClick={() => window.open('https://crm.smartuworld.com/registration.html', '_blank')} className="default-btn" target='_blank'>
                   Register Your Business
                  </Link>
                  </div>

                <div className="option-item">
                 <Link onClick={() => window.open('https://crm.smartuworld.com/newlead', '_blank')} className="default-btn" target='_blank'>
                   Raise a Query
                  </Link>
                  
                </div>
              </div>
            </div>
          </nav>
        </div>
      </div>
     
    </div>
    {/* End Navbar Area */}

    </>
  );
}

export default Header;
